// @generated by liquid-inject from src/sections/algolia-filter-collection/algolia-filter-collection.ts
// src/shared/algolia/filter-form.ts
var ALGOLIA_FILTER_FORM_SELECTOR = "[data-ais-sort-config] form#form-filter";
var ALGOLIA_DYNAMIC_BUTTON_SELECTOR = "[data-ais-refinements] button, [data-ais-sort] button, [data-ais-clear] button";
var ALGOLIA_SCROLL_PRESERVE_SELECTOR = "[data-ais-refinements] input, [data-ais-refinements] button";
function setAlgoliaFilterButtonTypes(form) {
  form.querySelectorAll(ALGOLIA_DYNAMIC_BUTTON_SELECTOR).forEach((button) => {
    if (!button.hasAttribute("type")) {
      button.type = "button";
    }
  });
}
function setupAlgoliaFilterForm(form) {
  if (form.dataset.algoliaSubmitGuard === "true") return;
  let preservedScrollTop = null;
  let restoreTimeout = null;
  const preserveScroll = (event) => {
    if (!(event.target instanceof Element)) return;
    if (!event.target.closest(ALGOLIA_SCROLL_PRESERVE_SELECTOR)) return;
    preservedScrollTop = form.scrollTop;
  };
  const restoreScroll = () => {
    if (preservedScrollTop === null) return;
    if (restoreTimeout !== null) {
      window.clearTimeout(restoreTimeout);
    }
    const scrollTop = preservedScrollTop;
    form.scrollTop = scrollTop;
    window.requestAnimationFrame(() => {
      form.scrollTop = scrollTop;
      window.requestAnimationFrame(() => {
        form.scrollTop = scrollTop;
      });
    });
    restoreTimeout = window.setTimeout(() => {
      form.scrollTop = scrollTop;
      preservedScrollTop = null;
      restoreTimeout = null;
    }, 80);
  };
  form.dataset.algoliaSubmitGuard = "true";
  form.addEventListener("submit", (event) => event.preventDefault());
  form.addEventListener("pointerdown", preserveScroll, true);
  form.addEventListener("click", preserveScroll, true);
  form.addEventListener("change", preserveScroll, true);
  setAlgoliaFilterButtonTypes(form);
  const observer = new MutationObserver(() => {
    setAlgoliaFilterButtonTypes(form);
    restoreScroll();
  });
  observer.observe(form, { childList: true, subtree: true });
}
function bootstrapAlgoliaFilterForms(root = document) {
  root.querySelectorAll(ALGOLIA_FILTER_FORM_SELECTOR).forEach(setupAlgoliaFilterForm);
}

// src/sections/algolia-filter-collection/algolia-filter-collection.ts
bootstrapAlgoliaFilterForms();
